module.exports = __webpack_public_path__ + "img/gf.5c61ef25.svg";